import styled from 'styled-components/macro';
import { TABLET_BREAKPOINT } from '../../../../app/constants';

interface Props {
  hasActiveItem: boolean;
}

export const StyledSummaryItem = styled.div<Props>`
  box-shadow: 0 0 0 1px ${(props) => props.theme.grey.light} inset;
  border-radius: 10px;
  > div {
    @media (max-width: ${TABLET_BREAKPOINT}px) {
      display: ${(props) => (props.hasActiveItem ? 'none' : 'block')};
    }
  }
  > .active {
    @media (max-width: ${TABLET_BREAKPOINT}px) {
      display: block;
    }
  }
  .d-table-cell {
    padding: 20px 10px;
    text-align: left;
  }
  .d-table-cell:first-child {
    padding-left: 30px;
  }
  .d-table-cell:last-child {
    padding-right: 30px;
  }
  .date-cell{
    white-space: nowrap;
  }
`;
